import { NavLink, Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { BRAND } from "@/lib/constants";

const links = [
  { to: "/", label: "Anasayfa" },
  { to: "/hakkinda", label: "Hakkımda" },
  { to: "/hizmetler", label: "Hizmetler" },
  { to: "/randevu", label: "Randevu" },
  { to: "/iletisim", label: "İletişim" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-cream-50/85 backdrop-blur-xl border-b border-cream-300"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 py-4 md:py-5 flex items-center justify-between gap-3">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex min-w-0 max-w-[calc(100%-3.25rem)] items-center gap-3 group lg:max-w-none"
        >
          <span className="w-9 h-9 rounded-full border border-gold flex items-center justify-center shrink-0">
            <span className="font-display italic text-gold text-sm tracking-normal">
              {BRAND.initials}
            </span>
          </span>
          <div className="min-w-0 leading-tight">
            <div className="font-display text-sm sm:text-base md:text-[19px] text-midnight tracking-normal truncate">
              {BRAND.name}
            </div>
            <div className="hidden sm:block text-[9px] tracking-[0.22em] md:tracking-[0.32em] uppercase text-lavender-700 -mt-0.5 truncate">
              {BRAND.tagline}
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l, i) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `relative font-body text-[13px] tracking-[0.18em] uppercase transition-colors duration-300 ${
                  isActive
                    ? "text-midnight"
                    : "text-lavender-700 hover:text-midnight"
                }`
              }
            >
              <span className="number-marker mr-2">0{i + 1}</span>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/randevu"
          data-testid="nav-cta-appointment"
          className="hidden lg:inline-flex items-center gap-2 px-6 py-2.5 border border-midnight text-midnight text-[11px] tracking-[0.22em] uppercase rounded-full hover:bg-midnight hover:text-cream-50 transition-all duration-500"
        >
          Randevu Al
        </Link>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Menüyü aç/kapat"
          onClick={() => setOpen(!open)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-midnight"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden max-h-[calc(100vh-72px)] overflow-y-auto bg-cream-50/98 backdrop-blur-xl border-t border-cream-300">
          <nav className="px-5 py-7 flex flex-col gap-5">
            {links.map((l, i) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-${l.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `font-display text-3xl tracking-normal ${
                    isActive ? "text-midnight" : "text-lavender-700"
                  }`
                }
              >
                <span className="number-marker mr-3">0{i + 1}</span>
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/randevu"
              data-testid="mobile-nav-cta"
              className="btn-midnight mt-4 self-start"
            >
              Randevu Al
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
